export const widewaters = [
	{
		"id": 1,
		"jump": "widewaters",
		"title": "",
		"pic": "../img/widewaters/iphones.jpg",
		"alt": "iPhone mockup screenshot of Wide Waters on Spotify",
		"center": "imagewide"
	},
	{
		"id": 2,
		"jump": "",
		"title": "",
		"pic": "../img/widewaters/logo2.png ",
		"center": "imagewide",
		"alt": "Wide Waters logo",
		
	},
	{
		"id": 3,
		"jump": "widewaters1",
		"title": "'Cabin In The Woods'",
		"desc": "Digital Album Art",
		"pic": "../img/widewaters/cabin.jpg",
		"alt": "Cabin in the Woods Part 1, Digital Album Art",
		"center": "imagewide spacing1"
	},
	{
		"id": 4,
		"jump": "widewaters2",
		"title": "'2021'",
		"desc": "Digital Album Art",
		"pic": "../img/widewaters/2021.jpg",
		"alt": "2021, Digital Single Art",
		"center": "imagewide spacing1"
		
	},
]